module.exports = __webpack_public_path__ + "img/logik.08c9f274.jpg";